import React, { useEffect, useRef, useState } from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaGlobe } from 'react-icons/fa';
import { Person2 } from '@mui/icons-material';
import useResize from '../hooks/useResize'

const VideoInstructor = ({ instructorData }) => {
	const [expanded, setExpanded] = useState(false);
	const [isOverflowing, setIsOverflowing] = useState(false);
	const deviceType = useResize()


	const bioRef = useRef(null);

	const socialIcons = {
		facebook: FaFacebook,
		twitter: FaTwitter,
		instagram: FaInstagram,
		linkedin: FaLinkedin,
		website: FaGlobe,
	};

	const checkOverflow = () => {
		const bioElement = bioRef.current;
		if (bioElement) {
			const wasExpanded = expanded;
			if (wasExpanded) setExpanded(false);


			setTimeout(() => {
				const isContentOverflowing = bioElement.scrollHeight > bioElement.clientHeight;
				setIsOverflowing(isContentOverflowing);
				if (wasExpanded) setExpanded(true);
			}, 0);
		}
	};

	useEffect(() => {
		checkOverflow();
		window.addEventListener('resize', checkOverflow);
		return () => window.removeEventListener('resize', checkOverflow);
	}, [instructorData?.bio]);

	return (
		<div className={`instructor-container ${expanded ? 'expanded' : ''}`}>
			<div className="instructor-section">
				<div className="instructor-image">
					<img width="100%" height="100%" src={instructorData?.imageUrl} alt="Instructor" />
				</div>

				<div className="instructor-info">
					<div className="instructor-header">
						<div className="instructor-name">
							<div className="instructor-text">
								<Person2 size={30} />
								<h3>INSTRUCTOR :</h3>
							</div>
							<h4>{instructorData?.name}</h4>
						</div>

						<div className="socials-container" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
							{instructorData?.socials?.map((social, index) => {
								const IconComponent = socialIcons[social.platform.toLowerCase()] || FaGlobe;
								return (
									<a
										key={index}
										href={social.url}
										target="_blank"
										rel="noopener noreferrer"
										style={{ color: 'white', fontSize: '20px' }}
									>
										<IconComponent />
									</a>
								);
							})}
						</div>
					</div>

					<p
						className={`instructor-bio ${expanded ? 'expanded' : ''}`}
						ref={bioRef}

					>
						{instructorData?.bio}
					</p>
					{deviceType === 'mobile' && (
						<p
							className={`instructor-bio-mobile ${expanded ? 'expanded' : ''}`}
							ref={bioRef}

						>
							{instructorData?.bio}
						</p>
					)}


					{isOverflowing && (
						<>
							<button className="view-more-btn" onClick={() => setExpanded(!expanded)}>
								{expanded ? 'Show Less' : 'More'}
							</button>
							{deviceType === 'mobile' && (
								<button className="view-more-btn-mobile" onClick={() => setExpanded(!expanded)}>
									{expanded ? 'Show Less' : 'More'}
								</button>
							)}
						</>
					)}

				</div>
			</div>
		</div>
	);
};

export default VideoInstructor;
